import { CSVParser } from "./types";

export function getDefaultState(): CSVParser {
    return {
		csvParsed: {},
		mandatoryFields: {},
		validHeadersName: {},
    }
}
